import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import manifest from '../public/microfrontend-manifest.json';

window[`render${manifest.microfrontendname}`] = (
  containerId,
  history,
  path,
  host,
  containerContext,
) => {
  const container = document.getElementById(containerId);
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App
        history={history}
        path={path}
        host={host}
        containerContext={containerContext}
      />
    </React.StrictMode>,
  );
};

window[`unmount${manifest.microfrontendname}`] = containerId => {
  const container = document.getElementById(containerId);
  const root = createRoot(container);

  if (container) root.unmount();
};

window.renderSelfContainedMicrofrontend = containerId => {
  window[`render${manifest.microfrontendname}`](containerId);
};